import React from 'react';
import { Link } from 'gatsby';
import cn from 'classnames';

import LocalImageOptimized from '../../LocalImage/LocalImageOptimized';
import TextBlock from '../blocks/TextBlock';
import { useWindowWidth } from '../../../utils/hooks';

import './VisualQuote.scss';

const VisualQuote = ({ blok }) => {
  const width = useWindowWidth();
  const { image_block, image_size, button, text_section, image_mobile, image_url } = blok || {};

  const isMobile = width < 500;

  return (
    <div className="visual-quote">
      <div className={cn("visual-quote__image-container", {
        "visual-quote__image-container--full": image_size === 'full',
        "visual-quote__image-container--mid": image_size === 'mid' || !image_size
      })}>
        {(isMobile ? image_mobile : image_block) && (
          image_url?.url ? (
            <a href={image_url.url} target='_blank' rel='noopener noreferrer'>
              <LocalImageOptimized
                imageUrl={(isMobile ? image_mobile : image_block).filename}
                alt={`Background banner ${(isMobile ? image_mobile : image_block).alt}`}
                customClass='carousel-background-image'
              />
            </a>
          ) : (
            <LocalImageOptimized
              imageUrl={(isMobile ? image_mobile : image_block).filename}
              alt={`Background banner ${(isMobile ? image_mobile : image_block).alt}`}
              customClass='carousel-background-image'
            />
          )
        )}
      </div>
      <div className="visual-quote__content">
        {text_section && <TextBlock text={text_section} />}

        {button && button.length > 0 && (
          <div className="visual-quote__cta-container">
            <Link
              to={button[0].url.url}
              className={cn("visual-quote__cta-button", `visual-quote__cta-button-${button[0].options}`)}>
              {button[0].label}
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default VisualQuote;